import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

const config = {
    apiKey: "AIzaSyBNdEtDtolTK7tLRRnTnfRWE-M0uFDQ9-w",
    authDomain: "natural-home-of-remedies.firebaseapp.com",
    projectId: "natural-home-of-remedies",
    storageBucket: "natural-home-of-remedies.appspot.com",
    messagingSenderId: "861119592423",
    appId: "1:861119592423:web:596aa3877297098b42ef42",
    measurementId: "G-1EWD1896FH"
}

firebase.initializeApp(config);

export function firebaseListener(func) {
  firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
      // console.log("User log in success", user);
      func(true, user)
    } else {
      // console.log("User log in failed", user);
      func(false)
    }
  }, function(error) {
    console.log(error)
  });
}

export const ref = firebase.database().ref();
export const firebaseAuth = firebase.auth;
export default {
  database: firebase.firestore(),
  auth: firebase.auth(),
  storage: firebase.storage()
};
